
export default class authenticationController {
    constructor(userService) {
        this.userService = userService;

        userService.getCurrent().then(resp => {
            this.account = resp.data;
        });
    }
}


// WEBPACK FOOTER //
// ./src/js/components/account/account.controller.js